import {
  SHAREABLE_LINK_MAIN_INFO_NDA_STATUS,
  ShareableLinkMainInfoNDAStatus,
} from 'models/ShareableLink';

export const getIsMainInfoNdaStatusReadyForSigning = (
  status: ShareableLinkMainInfoNDAStatus,
) => status === SHAREABLE_LINK_MAIN_INFO_NDA_STATUS.READY_FOR_SIGNING;

export const getIsMainInfoNdaStatusRejected = (
  status: ShareableLinkMainInfoNDAStatus,
) => status === SHAREABLE_LINK_MAIN_INFO_NDA_STATUS.REJECTED;

export const getIsMainInfoNdaStatusWaitingConnection = (
  status: ShareableLinkMainInfoNDAStatus,
) => status === SHAREABLE_LINK_MAIN_INFO_NDA_STATUS.WAITING_FOR_CONNECTION;

export const getIsMainInfoNdaStatusWaitingCountersign = (
  status: ShareableLinkMainInfoNDAStatus,
) => status === SHAREABLE_LINK_MAIN_INFO_NDA_STATUS.WAITING_FOR_COUNTER_SIGN;
